import React from 'react';
import { RouteProps } from 'react-router-dom';

import PublicRoute from './PublicRoute';

import { getUserData } from '../../../services/localSorage';

const PublicRouteContainer: React.FC<RouteProps> = (props: RouteProps) => {
  const { user, token } = getUserData();

  return <PublicRoute authenticated={Boolean(user?.id && token)} {...props} />;
};

export default PublicRouteContainer;
